// extracted by mini-css-extract-plugin
module.exports = {"team":"Team_team__XLbe_","boxWrapper":"Team_boxWrapper__wxZOX","teamBox":"Team_teamBox__SJfSa","teamContent":"Team_teamContent__LJr6e"};